// Types
import mixins from "vue-typed-mixins"; // Enums
const TicketProvider = ticketName => mixins().extend({
  provide() {
    return {
      [ticketName]: this
    };
  },
  data() {
    return {
      registeredTickets: [],
      tickets: {}
    };
  },
  methods: {
    registerTicket(component) {
      const path = [];
      const calcPath = comp => {
        if (comp === this || !comp._uid) return;
        path.push(comp._uid);
        calcPath(comp.$parent);
      };
      calcPath(component);
      this.registeredTickets.push({
        component: component._uid || 0,
        path
      });
      this.calculateTickets();
    },
    unregisterTicket(component) {
      const {
        _uid
      } = component;
      if (!_uid) return;
      const i = this.registeredTickets.findIndex(controller => controller.component === _uid);
      this.registeredTickets.splice(i, 1);
      this.$delete(this.tickets, _uid);
    },
    calculateTickets() {
      const allowedIds = this.registeredTickets.map(t => t.component);
      const filteredChildren = this.$children.filter(child => child._uid !== undefined && allowedIds.includes(child._uid));
      this.registeredTickets.forEach(controller => {
        const _uid = controller.component;
        if (!_uid) return;
        const {
          path
        } = controller;
        const index = filteredChildren.findIndex(child => child._uid === path[path.length - 1]);
        this.$set(this.tickets, _uid, index);
      });
    }
  }
});
export default TicketProvider;